import { Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import BackgroundParticles  from './components/BackgroundParticles';
import SidebarNav           from './components/SidebarNav';
import SidebarEntryList     from './components/SidebarEntryList';
import { RailProvider }     from './context/RailContext';
import Home                 from './pages/Home';
import Experience           from './pages/Experience';
import Projects             from './pages/Projects';
import Contact              from './pages/Contact';
import Library              from './pages/Library';
import Inspo                from './pages/Inspo';
import Secret               from './pages/Secret';

import './index.css';

export default function App() {
    const { pathname } = useLocation();
    const isSecret = pathname === '/secret';
    const appClassName = ['app', isSecret ? 'app--secret' : null, (pathname === '/' || pathname === '/inspo') ? 'app--home' : null]
        .filter(Boolean)
        .join(' ');

    return (
        <RailProvider>
            <div className="site-shell">
                <BackgroundParticles />

                <main className={appClassName}>
                    <div className="app-layout">
                        {!isSecret && (
                            <>
                                <header className="app-header-block">
                                    <div className="content">
                                        <h1>
                                            Erick{' '} A. {' '}
                                            <Link to="/secret" className="secret-trigger">
                                                C
                                            </Link>
                                            ifuentes
                                        </h1>
                                        <p className="subtitle">Computer Scientist & Developer</p>
                                    </div>
                                </header>

                                <aside className="app-sidebar">
                                    <SidebarNav />
                                    <SidebarEntryList />
                                </aside>
                            </>
                        )}

                        <div className="app-main">
                            <Routes>
                                <Route path="/"           element={<Home />} />
                                <Route path="/experience" element={<Experience />} />
                                <Route path="/projects"   element={<Projects />} />
                                <Route path="/library"    element={<Library />} />
                                <Route path="/inspo"      element={<Inspo />} />
                                <Route path="/contact"    element={<Contact />} />
                                <Route path="/resume"     element={<Navigate to="/resume.pdf" replace />} />
                                <Route path="/secret"     element={<Secret />} />
                            </Routes>
                        </div>
                    </div>
                </main>
            </div>
        </RailProvider>
    );
}
